import { useEffect, useState } from 'react';
import { type GeocodingSuggestion, geocodeForward } from '@/api/mapbox';

export const useGeocoding = (query: string) => {
  const [suggestions, setSuggestions] = useState<Array<GeocodingSuggestion>>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (query.trim().length < 2) {
      setSuggestions([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    const timer = setTimeout(() => {
      geocodeForward(query)
        .then((results) => {
          setSuggestions(results);
        })
        .catch(() => {
          setSuggestions([]);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }, 300);

    return () => {
      clearTimeout(timer);
    };
  }, [query]);

  return { suggestions, isLoading };
};
